import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';
import { normalizePath } from '@/Domain/utils/normalizePath/normalizePath';
import { SCENARIO_ID } from '@/context';

export const usePageviewPostHog = () => {
  const location = useLocation();
  const postHog = usePostHog();

  const prevPathRef = useRef<string | null>(null);
  const entryPathRef = useRef<string | null>(null);

  useEffect(() => {
    const normalizedPath = normalizePath(window.location.href);

    if (!entryPathRef.current) {
      entryPathRef.current = normalizedPath;
    }

    postHog.capture(PostHogEventEnum.Pageview, {
      scenario_id: SCENARIO_ID,
      $pathname: normalizedPath,
      $session_entry_url: entryPathRef.current,
      $prev_pageview_pathname: prevPathRef.current,
    });

    prevPathRef.current = normalizedPath;
  }, [location]);
};
